export default __webpack_public_path__ + "navigation-examples-custom-waypoint-960-6497d4733f896dc29e9a3974f670fd0e.webp";